<template>
  <not-authenticated>
    <v-card
      class="elevation-0 mx-auto login-area-box"
      color="transparent"
      flat>
      <h1 class="subtitle-1 mediumGray--text text-center mb-6">
        Acessar plataforma
      </h1>
      <v-card-text class="pt-0">
        <v-form
          ref="formInvited"
          v-model="validInvited"
          lazy-validation>
          <v-text-field
            v-model="code"
            label="Seu código"
            type="text"
            :rules="requiredRules"
            autofocus
            max-length="6"
            required />

          <v-text-field
            v-if="isValid"
            ref="focusDocument"
            v-model="invite.document"
            v-mask="mask.cpf"
            label="Seu cpf"
            type="text"
            :rules="cpfRules"
            required />

          <v-card-actions class="px-3">
            <v-spacer />
            <v-btn
              :loading="isLoading"
              color="primary"
              depressed
              :disabled="!validInvited"
              @click="invitedSubmit">
              Entrar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </not-authenticated>
</template>

<script>
  const NotAuthenticated = () => import('@/components/NotAuthenticated')
  import validate from '@/mixins/validate'
  import masks from '@/mixins/masks'

  export default {
    components: {
      NotAuthenticated
    },
    mixins: [ validate, masks ],
    data () {
      return {
        isLoading: false,
        invite: {
          code: '',
          document: ''
        },
        validInvited: false
      }
    },
    computed: {
      isValid () {
        return this.invite.code.length === 6
      },
      code: {
        get: function () {
          // if (this.$route.query.code) {
          //   this.invite.code = this.$route.query.code
          // }

          return this.$route.query.code
        },
        set: function (newValue) {
          this.invite.code = newValue
          return this.invite.code
        }
      }
    },
    watch: {
      isValid (result) {
        this.$nextTick(() => {
          result && this.focusElement()
        })
      }
    },
    methods: {
      invitedSubmit () {
        if (this.$refs.formInvited.validate()) {
          this.isLoading = true
          const code = this.invite.code
          const document = this.invite.document

          this.$store.dispatch('app/inviteCode', { code, document })
            .then(caseId => {
              this.isLoading = false
              this.$router.push({ name: 'Case', params: { caseId } })
            })
            .catch((error) => {
              this.errorLogin(error)
              this.isLoading = false
              this.validLogin = !this.isLoading
            })
        }
      },
      errorLogin () {
        this.$root.$emit('snackbar', {show: true, color: 'error', text: 'Código ou cpf não confere'})
      },
      _setUserToRaven (/* user */) {
        // Confirmar se o groups está passando
        // Raven.setUserContext({
        //   email: user.email,
        //   id: user.id,
        //   groups: user.groups
        // })
      },
      focusElement () {
        this.$refs.focusDocument.focus()
      }
    }
  }
</script>
